export const API_PATHS = {
  PROVIDERS: {
    SUPABASE: {
      ROOT: "/providers/supabase",
      AUTOCOMPLETE: "/providers/supabase/autocomplete",
      ADDRESSES: {
        INDEX: "/providers/supabase/addresses",
        AUTOCOMPLETE: "/providers/supabase/addresses/autocomplete",
      },
      HOMES: {
        INDEX: "/providers/supabase/homes",
        PREFERENCES: "/providers/supabase/homes/preferences",
        SITEMAP: "/providers/supabase/homes/sitemap",
        STATIC_PARAMS: "/providers/supabase/homes/static-params",
        PREVIEW_STATIC_PARAMS: "/providers/supabase/homes/preview-static-params",
        PROVIDER_ID_EXISTS: "/providers/supabase/homes/provider-id-exists",
      },
      /**
       * @deprecated
       */
      BUYERS: "/providers/supabase/buyers",
      BROKERS: {
        INDEX: "/providers/supabase/brokers",
        BY_EMAIL: "/providers/supabase/brokers/by-email",
        BY_NAME: "/providers/supabase/brokers/by-name",
      },
      BROKER_AREAS: {
        REVIEW: "/providers/supabase/broker-areas",
        APPROVE: "/providers/supabase/broker-areas",
        DISMISS: "/providers/supabase/broker-areas",
        PENDING: "/providers/supabase/broker-areas",
      },
      INTERESTS: {
        ROOT: "/providers/supabase/interests",
        HOME: "/providers/supabase/interests/home",
      },
      PROJECT_INTERESTS: "/providers/supabase/project-interests",
      WISHLISTS: "/providers/supabase/wishlists",
      VIEWING_PARTICIPANTS: "/providers/supabase/viewing_participants",
      SEARCHES: {
        INDEX: "/providers/supabase/searches",
        CREATE: "/providers/supabase/searches/create",
        SITEMAP: "/providers/supabase/searches/sitemap",
      },
      MUNICIPALITIES: {
        INDEX: "/providers/supabase/municipalities",
        NAME: "/providers/supabase/municipalities/name",
        BY_NAME: "/providers/supabase/municipalities/by-name",
        SITEMAP: "/providers/supabase/municipalities/sitemap",
      },
      AREAS: {
        INDEX: "/providers/supabase/areas",
        NAME: "/providers/supabase/areas/name",
        BY_NAME: "/providers/supabase/areas/by-name",
        SITEMAP: "/providers/supabase/areas/sitemap",
      },
      PROJECTS: {
        INDEX: "/providers/supabase/projects",
        SITEMAP: "/providers/supabase/projects/sitemap",
        PROVIDER_ID_EXISTS: "/providers/supabase/homes/provider-id-exists",
        MAP: "/providers/neondatabase/projects/map",
      },
      USERS: {
        INDEX: "/providers/supabase/users",
        ME: "/providers/supabase/users/me",
        SYNC_MATCHING_ENABLED: "/providers/supabase/users/me/sync-matching-enabled",
        ACTION: "/providers/supabase/users/action",
        LOOKUP: "/providers/supabase/users/lookup",
      },
    },
    VITEC: {
      USER: {
        SYNC: "/providers/vitec/user/sync",
      },
      ESTATE: {
        SYNC: "/providers/vitec/estate/sync",
      },
      PROJECT: {
        SYNC: "/providers/vitec/project/sync",
      },
    },
    NEONDATABASE: {
      ROOT: "/providers/neondatabase",
      SPECULATORS: "/providers/neondatabase/speculators",
      BROKERS: "/providers/neondatabase/brokers",
      HOMES: {
        INDEX: "/providers/neondatabase/homes",
        MAP: "/providers/neondatabase/homes/map",
      },
      HOMES_AND_BROKERS: "/providers/neondatabase/homes-and-brokers",
      PROJECTS: "/providers/neondatabase/projects",
      SEARCHES: "/providers/neondatabase/searches",
      MUNICIPALITIES: "/providers/neondatabase/municipalities",
      AREAS: "/providers/neondatabase/areas",
    },
    CUSTOMERIO: {
      USER: {
        MAGICLINK: "/providers/customerio/user/magiclink",
      },
      SELLER: {
        HOME_PUBLISHED: "/providers/customerio/seller/home-published",
      },
    },
  },
} as const;
